/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { ParcLimitropheDto } from '../models/parc-limitrophe-dto';
import { ParcLimitropheForConfigurationDto } from '../models/parc-limitrophe-for-configuration-dto';


/**
 * Fonctions de gestion des parcs limitrophes des recyparcs
 */
@Injectable({
  providedIn: 'root',
})
export class ParcsLimitrophesRecyparcsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation parcLimitropheGet
   */
  static readonly ParcLimitropheGetPath = '/api/parcs-limitrophes-recyparcs/{id}';

  /**
   * Renvoie le recyparc limitrophe spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `parcLimitropheGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  parcLimitropheGet$Response(params: {

    /**
     * Identifiant du recyparc limitrophe
     */
    id: number;
  }): Observable<StrictHttpResponse<ParcLimitropheDto>> {

    const rb = new RequestBuilder(this.rootUrl, ParcsLimitrophesRecyparcsService.ParcLimitropheGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ParcLimitropheDto>;
      })
    );
  }

  /**
   * Renvoie le recyparc limitrophe spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `parcLimitropheGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  parcLimitropheGet(params: {

    /**
     * Identifiant du recyparc limitrophe
     */
    id: number;
  }): Observable<ParcLimitropheDto> {

    return this.parcLimitropheGet$Response(params).pipe(
      map((r: StrictHttpResponse<ParcLimitropheDto>) => r.body as ParcLimitropheDto)
    );
  }

  /**
   * Path part for operation parcLimitrophePut
   */
  static readonly ParcLimitrophePutPath = '/api/parcs-limitrophes-recyparcs/{id}';

  /**
   * Met à jour le recyparc limitrophe spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `parcLimitrophePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  parcLimitrophePut$Response(params: {

    /**
     * Identifiant du recyparc limitrophe à mettre à jour
     */
    id: number;

    /**
     * Recyparc limitrophe
     */
    body: ParcLimitropheDto
  }): Observable<StrictHttpResponse<ParcLimitropheDto>> {

    const rb = new RequestBuilder(this.rootUrl, ParcsLimitrophesRecyparcsService.ParcLimitrophePutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ParcLimitropheDto>;
      })
    );
  }

  /**
   * Met à jour le recyparc limitrophe spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `parcLimitrophePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  parcLimitrophePut(params: {

    /**
     * Identifiant du recyparc limitrophe à mettre à jour
     */
    id: number;

    /**
     * Recyparc limitrophe
     */
    body: ParcLimitropheDto
  }): Observable<ParcLimitropheDto> {

    return this.parcLimitrophePut$Response(params).pipe(
      map((r: StrictHttpResponse<ParcLimitropheDto>) => r.body as ParcLimitropheDto)
    );
  }

  /**
   * Path part for operation parcLimitropheDelete
   */
  static readonly ParcLimitropheDeletePath = '/api/parcs-limitrophes-recyparcs/{id}';

  /**
   * Supprime le recyparc limitrophe spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `parcLimitropheDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  parcLimitropheDelete$Response(params: {

    /**
     * Identifiant du recyparc limitrophe à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, ParcsLimitrophesRecyparcsService.ParcLimitropheDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime le recyparc limitrophe spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `parcLimitropheDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  parcLimitropheDelete(params: {

    /**
     * Identifiant du recyparc limitrophe à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.parcLimitropheDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation parcLimitropheGetList
   */
  static readonly ParcLimitropheGetListPath = '/api/parcs-limitrophes-recyparcs/list/{parcId}';

  /**
   * Renvoie la liste des recyparcs limitrophes d'un recyparc.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `parcLimitropheGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  parcLimitropheGetList$Response(params: {

    /**
     * Identifiant du recyparc d&#x27;origine
     */
    parcId: number;
  }): Observable<StrictHttpResponse<Array<ParcLimitropheDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ParcsLimitrophesRecyparcsService.ParcLimitropheGetListPath, 'get');
    if (params) {
      rb.path('parcId', params.parcId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ParcLimitropheDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des recyparcs limitrophes d'un recyparc.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `parcLimitropheGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  parcLimitropheGetList(params: {

    /**
     * Identifiant du recyparc d&#x27;origine
     */
    parcId: number;
  }): Observable<Array<ParcLimitropheDto>> {

    return this.parcLimitropheGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ParcLimitropheDto>>) => r.body as Array<ParcLimitropheDto>)
    );
  }

  /**
   * Path part for operation parcLimitropheGetListForUpdate
   */
  static readonly ParcLimitropheGetListForUpdatePath = '/api/parcs-limitrophes-recyparcs/list-config/{parcId}';

  /**
   * Renvoie la liste des recyparcs non-limitrophes, avec leurs distances respectives.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `parcLimitropheGetListForUpdate()` instead.
   *
   * This method doesn't expect any request body.
   */
  parcLimitropheGetListForUpdate$Response(params: {

    /**
     * Identifiant du recyparc d&#x27;origine
     */
    parcId: number;
  }): Observable<StrictHttpResponse<Array<ParcLimitropheForConfigurationDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ParcsLimitrophesRecyparcsService.ParcLimitropheGetListForUpdatePath, 'get');
    if (params) {
      rb.path('parcId', params.parcId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ParcLimitropheForConfigurationDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des recyparcs non-limitrophes, avec leurs distances respectives.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `parcLimitropheGetListForUpdate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  parcLimitropheGetListForUpdate(params: {

    /**
     * Identifiant du recyparc d&#x27;origine
     */
    parcId: number;
  }): Observable<Array<ParcLimitropheForConfigurationDto>> {

    return this.parcLimitropheGetListForUpdate$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ParcLimitropheForConfigurationDto>>) => r.body as Array<ParcLimitropheForConfigurationDto>)
    );
  }

  /**
   * Path part for operation parcLimitrophePostAll
   */
  static readonly ParcLimitrophePostAllPath = '/api/parcs-limitrophes-recyparcs/list-config/{parcId}';

  /**
   * Met à jour la liste des recyparcs limitrophes pour un recyparc.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `parcLimitrophePostAll()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  parcLimitrophePostAll$Response(params: {

    /**
     * Identifiant du recyparc d&#x27;origine
     */
    parcId: number;

    /**
     * Liste des recyparcs limitrophes
     */
    body: Array<ParcLimitropheForConfigurationDto>
  }): Observable<StrictHttpResponse<Array<ParcLimitropheForConfigurationDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ParcsLimitrophesRecyparcsService.ParcLimitrophePostAllPath, 'post');
    if (params) {
      rb.path('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ParcLimitropheForConfigurationDto>>;
      })
    );
  }

  /**
   * Met à jour la liste des recyparcs limitrophes pour un recyparc.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `parcLimitrophePostAll$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  parcLimitrophePostAll(params: {

    /**
     * Identifiant du recyparc d&#x27;origine
     */
    parcId: number;

    /**
     * Liste des recyparcs limitrophes
     */
    body: Array<ParcLimitropheForConfigurationDto>
  }): Observable<Array<ParcLimitropheForConfigurationDto>> {

    return this.parcLimitrophePostAll$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ParcLimitropheForConfigurationDto>>) => r.body as Array<ParcLimitropheForConfigurationDto>)
    );
  }

  /**
   * Path part for operation parcLimitropheLoadList
   */
  static readonly ParcLimitropheLoadListPath = '/api/parcs-limitrophes-recyparcs/load-list/{parcId}';

  /**
   * Renvoie la liste des recyparcs limitrophes d'un recyparc (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `parcLimitropheLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  parcLimitropheLoadList$Response(params: {

    /**
     * Identifiant du recyparc d&#x27;origine
     */
    parcId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, ParcsLimitrophesRecyparcsService.ParcLimitropheLoadListPath, 'post');
    if (params) {
      rb.path('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des recyparcs limitrophes d'un recyparc (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `parcLimitropheLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  parcLimitropheLoadList(params: {

    /**
     * Identifiant du recyparc d&#x27;origine
     */
    parcId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.parcLimitropheLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation parcLimitrophePost
   */
  static readonly ParcLimitrophePostPath = '/api/parcs-limitrophes-recyparcs/{parcId}';

  /**
   * Crée un recyparc limitrophe pour un recyparc.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `parcLimitrophePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  parcLimitrophePost$Response(params: {

    /**
     * Identifiant du recyparc d&#x27;origine
     */
    parcId: number;

    /**
     * Informations de recyparc limitrophe
     */
    body: ParcLimitropheDto
  }): Observable<StrictHttpResponse<ParcLimitropheDto>> {

    const rb = new RequestBuilder(this.rootUrl, ParcsLimitrophesRecyparcsService.ParcLimitrophePostPath, 'post');
    if (params) {
      rb.path('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ParcLimitropheDto>;
      })
    );
  }

  /**
   * Crée un recyparc limitrophe pour un recyparc.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `parcLimitrophePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  parcLimitrophePost(params: {

    /**
     * Identifiant du recyparc d&#x27;origine
     */
    parcId: number;

    /**
     * Informations de recyparc limitrophe
     */
    body: ParcLimitropheDto
  }): Observable<ParcLimitropheDto> {

    return this.parcLimitrophePost$Response(params).pipe(
      map((r: StrictHttpResponse<ParcLimitropheDto>) => r.body as ParcLimitropheDto)
    );
  }

}
